"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _helper = require("./helper");

var _Rating = require("./Rating.style");

var _class, _temp;

var Rating = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Rating, _PureComponent);

  function Rating() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Rating);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Rating)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBarPartClick", function (index) {
      return function () {
        _this.props.editable && _this.props.onBarPartClick(index);
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderBarPoints", function (rating, size, editable) {
      return (0, _helper.runNTimesReturn)(10, function (index) {
        return _react.default.createElement(_Rating.SkillBarPart, {
          theme: _this.props.theme,
          rating: rating,
          key: index,
          index: index,
          size: size,
          editable: editable,
          onClick: _this.onBarPartClick(index)
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Rating, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          rating = _this$props.rating,
          size = _this$props.size,
          editable = _this$props.editable,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["style", "className", "rating", "size", "editable"]);
      return _react.default.createElement(_Rating.SkillBar, (0, _extends2.default)({
        className: className,
        style: style
      }, other), this.renderBarPoints(rating, size, editable));
    }
  }]);
  return Rating;
}(_react.PureComponent), _temp)) || _class;

Rating.propTypes = {
  size: _propTypes.default.oneOf(['normal', 'large']),
  editable: _propTypes.default.bool,
  rating: _propTypes.default.number,
  style: _propTypes.default.object,
  className: _propTypes.default.string
};
Rating.defaultProps = {
  size: 'normal',
  editable: false,
  rating: 5,
  style: {},
  className: ''
};
var _default = Rating;
exports.default = _default;